import { restClient } from 'libs/restClient';
import { FETCH_REQUEST_COMMENTS, POST_COMMENT } from 'actions/types';

export function fetchRequestComments(requestId) {
  const url = `/requestcomments?where=requestid=${requestId}&include=submitter`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: FETCH_REQUEST_COMMENTS,
    payload
  };
}

export function postComment(requestId, comment) {
  const reqBody = {
    args: {
      requestid: requestId,
      comment
    }
  };

  const payload = restClient
    .post('/requestcomments', JSON.stringify(reqBody))
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: POST_COMMENT,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/comments.js